export const REQUEST_ORIGINS = 'selectOrigins/REQUEST_ORIGINS';
export const SET_ORIGINS = 'selectOrigins/SET_ORIGINS';
export const SET_SELECTED_ORIGINS = 'selectOrigins/SET_SELECTED_ORIGINS';
export const SET_AVAILABLE_ORIGINS = 'selectDestinations/SET_AVAILABLE_ORIGINS';
export const SET_AVAILABLE_ORIGINS_MAP = 'selectDestinations/SET_AVAILABLE_ORIGINS_MAP';
export const SET_FORCE_SINGLE_VALUE = 'selectOrigins/SET_FORCE_SINGLE_VALUE';
export const RESET_SELECTED_ORIGINS = 'selectOrigins/RESET_SELECTED_ORIGINS';
